// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import { FiEdit2, FiTrash2, FiEye, FiRefreshCw } from "react-icons/fi";
// import { authHeader } from "../../services/auth-header";
// import { BASE_URL } from "../../services/Api";
// import { debounce } from "lodash";
// import { useFetchProductTableData } from "./useFetchProductTableData";
// import Swal from "sweetalert2";
// import "../Brand/BrandComponents.css";

// const ProductComponents = ({
//     header,
//     tableTitle,
//     apiField,
//     addButton,
//     createRoute,
//     updateRoute,
//     viewRoute,
//     selectedBrand = "1",
//     selectedProductType = "Finished",
//     brands = [],
//     productTypes = [],
//     onBrandChange,
//     onProductTypeChange
// }) => {
//     const { pointindex } = useParams();
//     const navigate = useNavigate();

//     const count = [{ value: 5 }, { value: 10 }, { value: 20 }, { value: 50 }];

//     const [searchInput, setSearchInput] = useState("");
//     const [search, setSearch] = useState(encodeURIComponent(" "));
//     const [currentPage, setCurrentPage] = useState(pointindex ? pointindex - 1 : 0);
//     const [limit, setLimit] = useState(5);
//     const [sort, setSort] = useState("desc");
//     const [currentValue, setCurrentValue] = useState("id");
//     const [isRefreshing, setIsRefreshing] = useState(false);

//     const { data: projectionData, pages, totalEnteries, refetch } = useFetchProductTableData({
//         apiField,
//         limit,
//         sort,
//         currentValue,
//         search,
//         currentPage,
//         brandId: selectedBrand,
//         productType: selectedProductType
//     });

//     useEffect(() => {
//         const debounced = debounce(() => {
//             setSearch(encodeURIComponent(searchInput.trim() || " "));
//             setCurrentPage(0);
//         }, 300);
//         debounced();
//         return () => debounced.cancel();
//     }, [searchInput]);

//     useEffect(() => {
//         setCurrentPage(0);
//     }, [selectedBrand, selectedProductType]);

//     const limitHandler = (e) => {
//         setLimit(e.target.value);
//         setCurrentPage(0);
//     };

//     const sortHandler = (value) => {
//         setSort(sort === "asc" ? "desc" : "asc");
//         setCurrentValue(value);
//     };

//     const addButtonHandler = () => navigate(createRoute);

//     const refreshHandler = () => {
//         setIsRefreshing(true);
//         refetch();
//         setTimeout(() => setIsRefreshing(false), 600);
//     };

//     const updateHandler = (id) => {
//         navigate(`${updateRoute}/${id}/${currentPage + 1}`);
//     };

//     const deleteHandler = (id) => {
//         Swal.fire({
//             title: 'Are you sure?',
//             text: "You won't be able to revert this!",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, delete it!'
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 fetch(`${BASE_URL}${apiField}/delete/${id}`, {
//                     method: "DELETE",
//                     headers: authHeader()
//                 })
//                     .then(async (response) => {
//                         const responseText = await response.text();
//                         let responseData;
//                         try {
//                             responseData = JSON.parse(responseText);
//                         } catch {
//                             responseData = responseText;
//                         }
//                         if (response.ok) {
//                             await Swal.fire({
//                                 title: 'Deleted!',
//                                 text: typeof responseData === 'string'
//                                     ? responseData
//                                     : (responseData.message || 'Item deleted successfully'),
//                                 icon: 'success'
//                             });
//                             refetch();
//                         } else {
//                             throw new Error(typeof responseData === 'string'
//                                 ? responseData
//                                 : (responseData.message || 'Failed to delete item'));
//                         }
//                     })
//                     .catch(error => {
//                         Swal.fire({ title: 'Error', text: error.message, icon: 'error' });
//                     });
//             }
//         });
//     };

//     const viewHandler = (label, id) => {
//         if (label === "Id" && viewRoute) {
//             navigate(`${viewRoute}/${id}/${currentPage + 1}`);
//         }
//     };

//     const handleRecentPage = (i) => setCurrentPage(i - 1);

//     const previousHandler = () => {
//         setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
//     };

//     const nextHandler = () => {
//         setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
//     };

//     const renderPagination = () => {
//         const siblingsCount = 2;
//         const firstPage = 1;
//         const lastPage = pages;
//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
//                     {firstPage}
//                 </button>
//             );
//             pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`bc-page-btn${i === currentPage + 1 ? ' bc-page-btn--active' : ''}`}
//                     onClick={() => handleRecentPage(i)}
//                 >
//                     {i}
//                 </button>
//             );
//         }

//         if (endPage < lastPage - 1) {
//             pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
//             pageNumbers.push(
//                 <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
//                     {lastPage}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     };

//     return (
//         <div className="bc-card">

//             {/* ── TOOLBAR ── */}
//             <div className="bc-toolbar">
//                 {/* Left: Search (flex-grow) */}
//                 <input
//                     className="bc-search"
//                     type="text"
//                     placeholder="Search..."
//                     value={searchInput}
//                     onChange={(e) => setSearchInput(e.target.value)}
//                 />

//                 {/* Right: Filters + Show entries + Refresh + Add */}
//                 <div className="bc-toolbar__right">
//                     {/* Brand filter */}
//                     {brands.length > 0 && (
//                         <>
//                             <span className="bc-filter__label">Brand:</span>
//                             <select
//                                 className="bc-filter__select"
//                                 value={selectedBrand}
//                                 onChange={(e) => onBrandChange(e.target.value)}
//                             >
//                                 {brands.map((brand) => (
//                                     <option key={brand.id} value={brand.id}>
//                                         {brand.brandname}
//                                     </option>
//                                 ))}
//                             </select>
//                         </>
//                     )}

//                     {/* Product type filter */}
//                     {productTypes.length > 0 && (
//                         <>
//                             <span className="bc-filter__label">Type:</span>
//                             <select
//                                 className="bc-filter__select"
//                                 value={selectedProductType}
//                                 onChange={(e) => onProductTypeChange(e.target.value)}
//                             >
//                                 {productTypes.map((type) => (
//                                     <option key={type.value} value={type.value}>
//                                         {type.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         </>
//                     )}

//                     <span className="bc-entries__label">Show:</span>
//                     <select className="bc-entries__select" onChange={limitHandler} value={limit}>
//                         {count.map((item) => (
//                             <option key={item.value} value={item.value}>{item.value}</option>
//                         ))}
//                     </select>

//                     <button
//                         className={`bc-refresh-btn${isRefreshing ? ' bc-refresh-btn--spinning' : ''}`}
//                         onClick={refreshHandler}
//                         title="Refresh"
//                     >
//                         <FiRefreshCw size={14} />
//                     </button>

//                     {addButton && (
//                         <button className="bc-add-btn" onClick={addButtonHandler}>
//                             {addButton}
//                         </button>
//                     )}
//                 </div>
//             </div>

//             {/* ── TABLE ── */}
//             <div className="bc-table-wrapper">
//                 <table className="bc-table">
//                     <thead>
//                         <tr>
//                             {header.map((head) => (
//                                 head.label !== "Action" ? (
//                                     <th
//                                         key={head.field}
//                                         className={`bc-th bc-th--sortable${currentValue === head.field ? ' bc-th--active' : ''}`}
//                                         onClick={() => sortHandler(head.field)}
//                                     >
//                                         {head.label}
//                                         {currentValue === head.field && (
//                                             <span className="bc-sort-icon">
//                                                 {sort === 'asc' ? ' ↑' : ' ↓'}
//                                             </span>
//                                         )}
//                                     </th>
//                                 ) : (
//                                     <th key={head.field} className="bc-th">{head.label}</th>
//                                 )
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {projectionData?.length > 0 ? (
//                             projectionData.map((data) => (
//                                 <tr key={data.id} className="bc-tr">
//                                     {header.map((head) => (
//                                         <td key={head.field} className="bc-td">
//                                             {head.label === "Action" ? (
//                                                 <div className="bc-actions">
//                                                     <button
//                                                         className="bc-action-btn bc-action-btn--view"
//                                                         onClick={() => viewHandler("Id", data.id)}
//                                                         title="View"
//                                                     >
//                                                         <FiEye size={15} />
//                                                     </button>
//                                                     <button
//                                                         className="bc-action-btn bc-action-btn--edit"
//                                                         onClick={() => updateHandler(data.id)}
//                                                         title="Edit"
//                                                     >
//                                                         <FiEdit2 size={15} />
//                                                     </button>
//                                                     <button
//                                                         className="bc-action-btn bc-action-btn--delete"
//                                                         onClick={() => deleteHandler(data.id)}
//                                                         title="Delete"
//                                                     >
//                                                         <FiTrash2 size={15} />
//                                                     </button>
//                                                 </div>
//                                             ) : (
//                                                 <span
//                                                     className={`bc-cell-text${head.label === "Id" ? ' bc-cell-text--id' : ''}`}
//                                                     onClick={() => viewHandler(head.label, data.id)}
//                                                 >
//                                                     {data[head.field]}
//                                                 </span>
//                                             )}
//                                         </td>
//                                     ))}
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr className="bc-tr">
//                                 <td colSpan={header.length} className="bc-td bc-td--empty">
//                                     No data found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* ── PAGINATION ── */}
//             <div className="bc-pagination">
//                 <span className="bc-pagination__info">
//                     Showing {projectionData?.length || 0} of {totalEnteries} entries
//                 </span>

//                 <div className="bc-pagination__controls">
//                     <button
//                         className={`bc-nav-btn${currentPage === 0 ? ' bc-nav-btn--disabled' : ''}`}
//                         onClick={previousHandler}
//                         disabled={currentPage === 0}
//                         title="Previous"
//                     >
//                         <IoIosArrowBack />
//                     </button>

//                     <div className="bc-pages">
//                         {renderPagination()}
//                     </div>

//                     <button
//                         className={`bc-nav-btn${currentPage >= pages - 1 ? ' bc-nav-btn--disabled' : ''}`}
//                         onClick={nextHandler}
//                         disabled={currentPage >= pages - 1}
//                         title="Next"
//                     >
//                         <IoIosArrowForward />
//                     </button>
//                 </div>
//             </div>

//         </div>
//     );
// };

// export default ProductComponents;



import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FiEye, FiRefreshCw } from "react-icons/fi";
import { debounce } from "lodash";
import { useFetchProductTableData } from "./useFetchProductTableData";
import "../Brand/BrandComponents.css";

const ProductComponents = ({
    header,
    tableTitle,
    apiField,
    addButton,
    createRoute,
    updateRoute,
    viewRoute,
    selectedBrand = "1",
    selectedProductType = "Finished",
    brands = [],
    productTypes = [],
    onBrandChange,
    onProductTypeChange
}) => {
    const { pointindex } = useParams();
    const navigate = useNavigate();

    const count = [{ value: 5 }, { value: 10 }, { value: 20 }, { value: 50 }];

    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState(encodeURIComponent(" "));
    const [currentPage, setCurrentPage] = useState(pointindex ? pointindex - 1 : 0);
    const [limit, setLimit] = useState(5);
    const [sort, setSort] = useState("desc");
    const [currentValue, setCurrentValue] = useState("id");
    const [isRefreshing, setIsRefreshing] = useState(false);

    const { data: projectionData, pages, totalEnteries, refetch } = useFetchProductTableData({
        apiField,
        limit,
        sort,
        currentValue,
        search,
        currentPage,
        brandId: selectedBrand,
        productType: selectedProductType
    });

    useEffect(() => {
        const debounced = debounce(() => {
            setSearch(encodeURIComponent(searchInput.trim() || " "));
            setCurrentPage(0);
        }, 300);
        debounced();
        return () => debounced.cancel();
    }, [searchInput]);

    useEffect(() => {
        setCurrentPage(0);
    }, [selectedBrand, selectedProductType]);

    const limitHandler = (e) => {
        setLimit(e.target.value);
        setCurrentPage(0);
    };

    const sortHandler = (value) => {
        setSort(sort === "asc" ? "desc" : "asc");
        setCurrentValue(value);
    };

    const addButtonHandler = () => navigate(createRoute);

    const refreshHandler = () => {
        setIsRefreshing(true);
        refetch();
        setTimeout(() => setIsRefreshing(false), 600);
    };

    // Dedicated view handler - only for view button click
    const handleViewClick = (id) => {
        if (viewRoute) {
            navigate(`${viewRoute}/${id}/${currentPage + 1}`);
        }
    };

    const handleRecentPage = (i) => setCurrentPage(i - 1);

    const previousHandler = () => {
        setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
    };

    const nextHandler = () => {
        setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
    };

    const renderPagination = () => {
        const siblingsCount = 2;
        const firstPage = 1;
        const lastPage = pages;
        let pageNumbers = [];

        const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
                    {firstPage}
                </button>
            );
            pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`bc-page-btn${i === currentPage + 1 ? ' bc-page-btn--active' : ''}`}
                    onClick={() => handleRecentPage(i)}
                >
                    {i}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
                    {lastPage}
                </button>
            );
        }

        return pageNumbers;
    };

    return (
        <div className="bc-card">

            {/* ── TOOLBAR ── */}
            <div className="bc-toolbar">
                {/* Left: Search (flex-grow) */}
                <input
                    className="bc-search"
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                />

                {/* Right: Filters + Show entries + Refresh + Add */}
                <div className="bc-toolbar__right">
                    {/* Brand filter */}
                    {brands.length > 0 && (
                        <>
                            <span className="bc-filter__label">Brand:</span>
                            <select
                                className="bc-filter__select"
                                value={selectedBrand}
                                onChange={(e) => onBrandChange(e.target.value)}
                            >
                                {brands.map((brand) => (
                                    <option key={brand.id} value={brand.id}>
                                        {brand.brandname}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}

                    {/* Product type filter */}
                    {productTypes.length > 0 && (
                        <>
                            <span className="bc-filter__label">Type:</span>
                            <select
                                className="bc-filter__select"
                                value={selectedProductType}
                                onChange={(e) => onProductTypeChange(e.target.value)}
                            >
                                {productTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}

                    <span className="bc-entries__label">Show:</span>
                    <select className="bc-entries__select" onChange={limitHandler} value={limit}>
                        {count.map((item) => (
                            <option key={item.value} value={item.value}>{item.value}</option>
                        ))}
                    </select>

                    <button
                        className={`bc-refresh-btn${isRefreshing ? ' bc-refresh-btn--spinning' : ''}`}
                        onClick={refreshHandler}
                        title="Refresh"
                    >
                        <FiRefreshCw size={14} />
                    </button>

                    {addButton && (
                        <button className="bc-add-btn" onClick={addButtonHandler}>
                            {addButton}
                        </button>
                    )}
                </div>
            </div>

            {/* ── TABLE ── */}
            <div className="bc-table-wrapper">
                <table className="bc-table">
                    <thead>
                        <tr>
                            {header.map((head) => (
                                head.label !== "Action" ? (
                                    <th
                                        key={head.field}
                                        className={`bc-th bc-th--sortable${currentValue === head.field ? ' bc-th--active' : ''}`}
                                        onClick={() => sortHandler(head.field)}
                                    >
                                        {head.label}
                                        {currentValue === head.field && (
                                            <span className="bc-sort-icon">
                                                {sort === 'asc' ? ' ↑' : ' ↓'}
                                            </span>
                                        )}
                                    </th>
                                ) : (
                                    <th key={head.field} className="bc-th">{head.label}</th>
                                )
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {projectionData?.length > 0 ? (
                            projectionData.map((data) => (
                                <tr key={data.id} className="bc-tr">
                                    {header.map((head) => (
                                        <td key={`${data.id}-${head.field}`} className="bc-td">
                                            {head.label === "Action" ? (
                                                <div className="bc-actions">
                                                    {/* Only View button in Action column */}
                                                    <button
                                                        className="bc-action-btn bc-action-btn--view"
                                                        onClick={() => handleViewClick(data.id)}
                                                        title="View"
                                                    >
                                                        <FiEye size={15} />
                                                    </button>
                                                </div>
                                            ) : head.label === "Id" ? (
                                                <div className="bc-id-cell">
                                                    <button
                                                        className="bc-action-btn bc-action-btn--view bc-view-icon-left"
                                                        onClick={() => handleViewClick(data.id)}
                                                        title="View"
                                                    >
                                                        <FiEye size={15} />
                                                    </button>
                                                    <span className="bc-cell-text bc-cell-text--id">
                                                        {data[head.field]}
                                                    </span>
                                                </div>
                                            ) : (
                                                <span className="bc-cell-text">
                                                    {data[head.field]}
                                                </span>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr className="bc-tr">
                                <td colSpan={header.length} className="bc-td bc-td--empty">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* ── PAGINATION ── */}
            <div className="bc-pagination">
                <span className="bc-pagination__info">
                    Showing {projectionData?.length || 0} of {totalEnteries} entries
                </span>

                <div className="bc-pagination__controls">
                    <button
                        className={`bc-nav-btn${currentPage === 0 ? ' bc-nav-btn--disabled' : ''}`}
                        onClick={previousHandler}
                        disabled={currentPage === 0}
                        title="Previous"
                    >
                        <IoIosArrowBack />
                    </button>

                    <div className="bc-pages">
                        {renderPagination()}
                    </div>

                    <button
                        className={`bc-nav-btn${currentPage >= pages - 1 ? ' bc-nav-btn--disabled' : ''}`}
                        onClick={nextHandler}
                        disabled={currentPage >= pages - 1}
                        title="Next"
                    >
                        <IoIosArrowForward />
                    </button>
                </div>
            </div>

        </div>
    );
};

export default ProductComponents;